import React, { useContext } from 'react';
import { Context as ConfigContext } from '../Config';
import usePageClassName from '../hooks/usePageClassName';
import useFetchCategoryPage from '../hooks/useCategoryPageData';
import useTranslation from '../hooks/useTranslation';
import { CategoryContext } from '../contexts';
// import CategorySchema from '../toolkit/CategorySchema';
import WithTitle from '../toolkit/WithTitle';
import ErrorPage from './error';
import Error404Page from './error404';
import Error401Page from './error401';
const CategoryPage = ({ match }) => {
    const { t } = useTranslation();
    usePageClassName('category-page');
    const { categoryId } = match.params;
    const categoryMatch = categoryId.match(/^\d+/);
    let _categoryId = categoryMatch ? categoryMatch[0] : '';
    const { data, fetchingStatus } = useFetchCategoryPage(_categoryId);
    const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);
    if (fetchingStatus === 'is-fetching' ||
        fetchingStatus === 'not-started'
    // || fetchingStatus === 'NotAllowedError'
    )
        return React.createElement(Loader, null);
    if (fetchingStatus === 'NotFound')
        return React.createElement(Error404Page, null);
    if (fetchingStatus === 'LoginRequired')
        return React.createElement(Error401Page, null);
    if (fetchingStatus !== 'has-fetched' || !data || !data.category)
        return React.createElement(ErrorPage, null);
    const category = data.category;
    const title = t('pageTitles.category', '{{category.title}}', { category });
    const Page = pages.category.component;
    return (React.createElement(CategoryContext.Provider, { value: category },
        React.createElement(React.Fragment, null,
            React.createElement(WithTitle, { title: title },
                React.createElement(Page, { category: category })))));
};
CategoryPage.displayName = 'CategoryPage';
export default CategoryPage;
//# sourceMappingURL=category.js.map